export default __webpack_public_path__ + "static/sebastian_witalec-dbb37648d308b3d42bd469779dfe935b.png";